import * as React from "react";
import { Building2, Factory, Hospital, Store } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const sectors = [{
  id: 1,
  title: "Prima Asmara LLC",
  description: "Our USA-based hub for global trade, import-export, and manufacturer representation across international markets.",
  icon: Store
}, {
  id: 2,
  title: "Admas Transport LLC",
  description: "Specialized U.S. NEMT services, dispatching, and comprehensive transport business support solutions.",
  icon: Building2
}, {
  id: 3,
  title: "Afrex Solutions Kenya",
  description: "Leading provider of industrial supply, solar systems, and UN/NGO tender fulfillment in East Africa.",
  icon: Factory
}, {
  id: 4,
  title: "Afrex Solutions Guinea",
  description: "Strategic mining supply, project logistics, and distribution services tailored for the West African region.",
  icon: Hospital
}];
export default function SectorsWePower() {
  return <section data-section-id="263589" id="the-afrex-network" className="dark bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678736/img/world_map_watermark.png')] bg-center bg-no-repeat bg-contain" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            The AFREX Network
          </h2>
          <p className="font-default mt-4 text-muted-foreground max-w-2xl mx-auto text-lg">
            A multi-country business platform delivering excellence through our specialized affiliated companies across the USA, Kenya, and Guinea.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {sectors.map((sector, i) => {
          const Icon = sector.icon;
          return <Card key={sector.id} data-index={i} className="group relative overflow-hidden border-border/50 bg-card/40 backdrop-blur-md transition-all duration-300 hover:-translate-y-1.5 hover:border-t-primary hover:border-t-2 hover:shadow-xl hover:shadow-primary/5">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary/20">
                    <Icon className="h-6 w-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl text-primary">
                    {sector.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-default text-sm leading-relaxed text-muted-foreground">
                    {sector.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}